import React from "react";
import { Container, Form } from "reactstrap";
import { useFormik } from "formik";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useHistory } from "react-router-dom";
import ResultHandler from "../../../../components/ResultHandler";
import FormButtonHandler from "../../../../components/FormButtonHandler";
import { useResponse } from "../../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import FIELDS from "./CONSTANT";
import ContractForm from "./ContractForm";
import * as Yup from "yup";
import { addContract } from "../../../../api/contract";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const TYPES = {
  select: null,
  "add-more": [],
  "add-more-v2": [],
  checkbox: false,
  file: null,
  date: null,
  "file-v2": null,
};

const initialValues = {};
const FIELDS_VALIDATION = {};

FIELDS.forEach((f) => {
  initialValues[f.key] = TYPES[f.type] != undefined ? TYPES[f.type] : "";
  if (!["add-more-v2", "checkbox"].includes(f.type)) {
    if (f.type == "file") {
      FIELDS_VALIDATION[f.key + "_preview"] = Yup.string().required(
        "This Field Is Required"
      );
    } else if (f.type == "file-v2") {
      FIELDS_VALIDATION[f.key] = Yup.mixed().required("This Field Is Required");
    } else {
      FIELDS_VALIDATION[f.key] = Yup.string().required(
        "This Field Is Required"
      );
    }
  }
});

const AddContract = () => {
  const { t } = useTranslation();
  let navigate = useHistory();
  const { id: companyId } = useParams();

  const { setData, loading, error, success } = useResponse(addContract, () => {
    navigate.goBack();
  });

  // Form validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues,
    validationSchema: Yup.object(FIELDS_VALIDATION),
    onSubmit: (values) => {
      values.companyId = companyId;

      let formData = new FormData();
      for (let key in values) {
        if (Array.isArray(values[key])) {
          formData.append(key, JSON.stringify(values[key]));
        } else {
          formData.append(key, values[key]);
        }
      }
      setData({ type: "add", data: formData });
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={t("Contracts")}
            breadcrumbItem={t("Add") + " " + t("Contract")}
          />

          <Form
            className="needs-validation"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <ContractForm validation={validation} />

            <FormButtonHandler btnTxt="Add" loading={loading} />

            <ResultHandler
              error={error}
              success={success}
              successMsg={"Created Successfully!"}
            />
          </Form>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddContract;
